const BRIDGE_EVENT_TYPES = {
    APPLICATION_LOADED: 'APPLICATION_LOADED',
    CLOSE_APPLICATION: 'CLOSE_APPLICATION',
    PURCHASE_STATUS: 'PURCHASE_STATUS',
    ESCAPE_BUTTON: 'ESCAPE_BUTTON',
};

export { BRIDGE_EVENT_TYPES };
//# sourceMappingURL=bridgeEvents.js.map
